import { useTranslation } from 'react-i18next';
import { useChatUnreadChats } from '../hooks/useChatUnreadChats';

/** D-326: the unread-chats counter on the "שיחות" menu row / mobile tab. Renders nothing at 0. */
export default function ChatCountBadge({ className = '' }: { className?: string }) {
  const { t } = useTranslation();
  const n = useChatUnreadChats();
  if (n <= 0) return null;
  return (
    <span
      data-testid="menu-chat-count"
      aria-label={t('chatScreen.unreadChats', { count: n })}
      className={`min-w-5 h-5 px-1 rounded-full bg-solid-success text-white text-xs font-semibold tabular-nums flex items-center justify-center ${className}`}
    >
      {n > 99 ? '99+' : n}
    </span>
  );
}
